import React, { useState, useEffect } from 'react'
import Client from '../../services/eventEmitter'

import Dialog from '../Dialog'
import Button from '../Button'

import { Box, Typography } from '@material-ui/core'

// --------------- 𝕄𝕖𝕥𝕒𝕕𝕒𝕥𝕒 ---------------

const client = Client

const events = {
  open: '@portalEcosis/CONFIRMATIONDIALOG/open',
  close: '@portalEcosis/CONFIRMATIONDIALOG/close',
  confirm: '@portalEcosis/CONFIRMATIONDIALOG/confirm',
  cancel: '@portalEcosis/cancelATIONDIALOG/cancel',
}

// --------------- 𝕌𝕥𝕚𝕝𝕤 ---------------

export const confirmationDialog = {
  async open(title, message, { onlyMessage = false } = {}) {
    client.emit(events.open, { title, message, onlyMessage })

    return new Promise((resolve) => {
      client.once(events.confirm, () => resolve(true))
      client.once(events.cancel, () => resolve(false))
    })
  },
  close() {
    client.emit(events.close)
  },
}

// --------------- 𝕄𝕒𝕚𝕟 ---------------

export function ConfirmationDialog() {
  const [dialog, setDialog] = useState({
    open: false,
    title: '',
    message: '',
    onlyMessage: false,
  })

  function handleOpen(options) {
    setDialog({
      open: true,
      title: options.title,
      message: options.message,
      onlyMessage: options.onlyMessage,
    })
  }

  function handleClose() {
    setDialog((previousDialog) => ({ ...previousDialog, open: false }))
  }

  function handleConfirm() {
    client.emit(events.confirm)
  }

  function handleCancel() {
    client.emit(events.cancel)
  }

  useEffect(() => {
    client.on(events.open, handleOpen)
    client.on(events.close, handleClose)

    return () => {
      client.removeEventListener(events.open, handleOpen)
      client.removeEventListener(events.close, handleClose)
    }
  }, [])

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={dialog.open}
      title={dialog.title}
      actions={
        dialog.onlyMessage ? (
          <Button type="button" onClick={handleCancel}>
            Fechar
          </Button>
        ) : (
          <>
            <Button
              autoFocus
              color="primary"
              variant="outlined"
              type="button"
              onClick={handleCancel}
            >
              Cancelar
            </Button>

            <Button
              color="primary"
              variant="contained"
              type="button"
              onClick={handleConfirm}
            >
              Confirmar
            </Button>
          </>
        )
      }
    >
      <Box my="1rem">
        <Typography variant="body1" color="textSecondary">
          {dialog.message}
        </Typography>
      </Box>
    </Dialog>
  )
}

export default ConfirmationDialog
